export function emit(name: string, detail?: unknown): void {
  document.dispatchEvent(new CustomEvent(name, { detail }));
}

export function on(name: string, handler: (e: CustomEvent) => void): () => void {
  const wrapped = handler as EventListener;
  document.addEventListener(name, wrapped);
  return () => document.removeEventListener(name, wrapped);
}

export function toast(message: string, type: 'success' | 'error' | 'info' = 'info'): void {
  emit('toast', { message, type });
}
